import * as yup from "yup";

const validation = (errors) => {
  const requiredString = yup
    .string()
    .typeError(errors.REQUIRED)
    .required(errors.REQUIRED);
  return yup.object().shape({
    budget: yup.mixed().when("selectedLevel", {
      is: (value) => value === null,
      then: yup
        .object()
        .typeError(errors.REQUIRED)
        .shape({
          min: requiredString,
          max: requiredString,
        })
        .required(errors.REQUIRED),
    }),
  });
};

export default validation;
